import React from 'react';
import PropTypes from 'prop-types';

// this indicates whether to change from 'fas' to 'far'
// 'fas' is generally heavier - "Solid"
// 'far' is lighter, "regular"
// Not all are available in non-pro version.  In general, the solid
// version is available.

// must be defined outside of the component to avoid re-rendering loops
const defaultStyle = {};
const Icon = ({
  weight: _weight = 'fas',
  glyph,
  style: _style = defaultStyle,
  className: _className = '',
  ariaLabel: _ariaLabel = null
}) => /*#__PURE__*/React.createElement("i", {
  "aria-label": _ariaLabel || glyph,
  className: `${_weight} fa-${glyph}${_className ? ` ${_className}` : ''}`,
  style: _style
});
Icon.propTypes = {
  glyph: PropTypes.string.isRequired,
  style: PropTypes.shape({}),
  weight: PropTypes.string,
  className: PropTypes.string,
  ariaLabel: PropTypes.string
};
export default Icon;